import React, { useEffect, useMemo } from "react";
import { PreparationSectionType } from "../../navigation/preparation-route-props";
import { Route, Routes, useMatch } from "react-router-dom";
import { BTMActiveReturns } from "./btm-active-returns/btm-active-returns";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useUserSessionContext } from "../../../common/context/application-context/user-session-context-provider";
import { BTMFinalizedReturns } from "./btm-finalized-returns/btm-finalized-returns";
import { useWarehouseContext } from "../pallet/warehouse-context/warehouse-context-provider";
import { BtmRequestDetailsPage } from "./btm-request-details/btm-request-details-page";

interface IBTMReturnsRouterProps {
    setRouteExpanded: (route: PreparationSectionType) => void;
}

export const BTMReturnsRouter = (props: IBTMReturnsRouterProps) => {
    useEffect(() => { props.setRouteExpanded("btm-returns"); }, []);
    const { locale } = useUserSessionContext();
    const queryClient = useMemo(() => new QueryClient(), []);
    const { code: warehouseCode } = useWarehouseContext();
    const pathMatch = useMatch("btm-returns/:page/:warehouse");

    return <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
            <Routes>
                <Route path={`active/:warehouseCode?`} element={<BTMActiveReturns warehouseCode={warehouseCode || pathMatch?.params.warehouse} />} />
                <Route path={`finalized/:warehouseCode?`} element={<BTMFinalizedReturns warehouseCode={warehouseCode || pathMatch?.params.warehouse} />} />
                <Route path={`details/:id`} element={<BtmRequestDetailsPage requestId={pathMatch?.params.warehouse} />} />
            </Routes>
        </LocalizationProvider>
    </QueryClientProvider>;
};
